var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 5.56881V11.4469C33 12.586 32.0766 13.5094 30.9375 13.5094H25.0594C23.9204 13.5094 22.9969 12.586 22.9969 11.4469C22.9969 10.3078 23.9204 9.38438 25.0594 9.38438H26.6353C24.3579 6.12015 20.6255 4.125 16.5 4.125C11.367 4.125 6.84183 7.21314 4.97153 11.9923C4.55632 13.0531 3.35981 13.5764 2.29917 13.1613C1.2384 12.7462 0.715043 11.5497 1.13019 10.489C2.32637 7.43248 4.3881 4.82322 7.09249 2.94332C9.86249 1.01778 13.1155 0 16.5 0C19.8845 0 23.1375 1.01778 25.9075 2.94325C27.0081 3.70831 28.0023 4.59428 28.875 5.58196V5.56888C28.875 4.4298 29.7984 3.50638 30.9375 3.50638C32.0766 3.50638 33 4.42973 33 5.56881ZM30.7008 19.8387C29.6401 19.4235 28.4437 19.947 28.0285 21.0077C26.1582 25.7869 21.633 28.875 16.5 28.875C12.4622 28.875 8.80082 26.9637 6.5117 23.8219H7.94056C9.07964 23.8219 10.0031 22.8985 10.0031 21.7594C10.0031 20.6203 9.07964 19.6969 7.94056 19.6969H2.0625C0.92342 19.6969 0 20.6203 0 21.7594V27.6375C0 28.7766 0.92342 29.7 2.0625 29.7C3.20158 29.7 4.125 28.7766 4.125 27.6375V27.4181C4.9977 28.4058 5.99188 29.2917 7.09249 30.0567C9.86249 31.9822 13.1155 33 16.5 33C19.8845 33 23.1375 31.9822 25.9075 30.0567C28.6119 28.1768 30.6736 25.5676 31.8698 22.511C32.285 21.4503 31.7616 20.2539 30.7008 19.8387Z",
    fill: "#224846"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f3d27d4ab56db051b9d37bf00bf45064.svg";
export { ForwardRef as ReactComponent };